import {UrunGrup} from './urun-grup';

export class MultipleSelectModel {
  id: number;
  isim: string;
  childrens: UrunGrup[];

}
